import { QueryKeys } from '@/api/hooks/queryKeys.ts'
import { ApiPaths } from '@/util/paths'
import type { AllTaskCategories, TaskCategoryPreview } from '@/util/views/task.view'
import { useQuery } from '@tanstack/react-query'
import axios from 'axios'

export const useTaskCategoriesQuery = () => {
  return useQuery<TaskCategoryPreview[], Error>({
    queryKey: [QueryKeys.TASK_CATEGORIES],
    queryFn: async () => {
      const response = await axios.get<AllTaskCategories>(ApiPaths.TASK)
      return response.data.categories
    }
  })
}
